module.exports = __webpack_public_path__ + "assets/img/tzjl-1.29fd8c84.jpg";